export enum EmailEnum {
  ltlItRatingTeam = 'LTLITEdgeCorrectionsTeam@xpo.com',
  lTLnightaudit = 'LTLnightaudit@xpo.com',
};
